// Open-source reverse geocoding via OpenStreetMap Nominatim
// Docs: https://nominatim.org/release-docs/latest/api/Reverse/
// Be mindful of rate limits; cache results client-side if needed.
export async function reverseGeocode(lat, lng) {
  const params = new URLSearchParams({
    format: "jsonv2",
    lat: String(lat),
    lon: String(lng),
    addressdetails: "1",
    zoom: "16",
  });
  // Use local proxy to avoid CORS issues
  const url = `/api/geocode/reverse?${params.toString()}`;

  const res = await fetch(url, {
    headers: {
      Accept: "application/json",
    },
  });

  if (!res.ok) {
    const text = await res.text();
    console.error(`Geocode error: HTTP ${res.status}. Response: ${text.substring(0, 100)}`);
    throw new Error(`Geocode HTTP ${res.status}`);
  }

  const text = await res.text();
  try {
    const data = JSON.parse(text);
    if (!data || (!data.display_name && !data.address)) {
      throw new Error("Geocode error: empty response");
    }
    // Prefer a concise three-part address: City, District, Country
    const addr = data.address || {};
    const city = addr.city || addr.town || addr.village || addr.hamlet;
    const district =
      addr.district || addr.county || addr.state_district || addr.suburb;
    const country = addr.country;
    const compact = [city, district, country].filter(Boolean).slice(0, 3);
    if (compact.length) return compact.join(", ");
    // Fallback to display_name or a broader construction
    return data.display_name || [addr.state, country].filter(Boolean).join(", ");
  } catch (e) {
    console.error("Failed to parse Geocode JSON. Response starts with:", text.substring(0, 100));
    throw e;
  }
}
